//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

export const PROJECT_PATH_IMPORT = 'project-path-import'
export const PATH_DATABASE_IMPORT = 'path-database-import'
